import { useEffect } from 'react';

export default function ImportArtlabsViewer({ meshkraftKey }) {
  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      'https://assets.artlabs.ai/js/viewer/latest/artlabs-viewer.min.js';
    script.type = 'module';
    script.setAttribute('data-artlabs-key', meshkraftKey);
    script.setAttribute('data-artlabs-drafts', 'true');
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [meshkraftKey]);

  return null;
}
